<template>
  <layout title="Courses">
    <div class="row mb-4">
      <div class="col-10">
        <h2 class="page-heading">Classrooms</h2>
      </div>

      <div class="col-2">
        <inertia-link
          class="btn btn-primary float-right"
          :href="route('classrooms.create')"
        >
          + Add New
        </inertia-link>
      </div>
    </div>

    <div class="card shadow-sm p-3 mb-5 bg-white rounded mt-2">
      <div class="card-body">
        <FlashMessage :flash="flash" />

        <div class="row mb-2">
          <div class="col-md-8"></div>
          <div class="col-md-4">
            <form @submit.prevent="search()">
              <input
                v-model="searchQuery"
                type="text"
                class="form-control"
                placeholder="Search.."
              />
            </form>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <table class="table">
              <thead class="thead-light xthead-dark">
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Course</th>
                  <th scope="col">Teacher</th>
                  <th scope="col">Students</th>
                  <th scope="col">Created Date</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="classroom in classrooms.data" :key="classroom.id" @click="navigateToEdit(classroom.id)">
                  <td :title="classroom.description">{{ classroom.name }}</td>
                  <td>{{ classroom.course ? classroom.course.name : '' }}</td>
                  <td>{{ classroom.teacher ? classroom.teacher.name : '' }}</td>
                  <td>{{ classroom.students_count }}</td>
                  <td>{{ classroom.created_at }}</td>
                  <td>

                    <div class="dropdown d-inline" @click.stop="toggleActions(classroom.id)">
                      <button class="btn btn-sm btn-outline-primary mr-2" :id="'dropdown-toggle-'+classroom.id" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Manage
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <inertia-link @click.stop class="dropdown-item" :href="route('classrooms.students', classroom.id)" >Students</inertia-link>
                        <inertia-link @click.stop class="dropdown-item" :href="route('classrooms.sessions', classroom.id)">Sessions</inertia-link>
                        <div class="dropdown-divider"></div>
                        <a @click.stop="showDeleteConfirmationModal(classroom)" class="dropdown-item" style="color: red">Delete</a>
                      </div>
                    </div>
                    <!-- <button
                      type="button"
                      class="btn btn-sm x-btn-danger btn-outline-danger"
                      @click.stop="showDeleteConfirmationModal(classroom)"
                    >
                      Delete
                    </button> -->
                  </td>
                </tr>
              </tbody>
              <tbody v-if="!classrooms.data || !classrooms.data.length">
                <tr>
                  <td colspan="6">No data to display</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <nav aria-label="Page navigation example">
          <ul class="pagination justify-content-end">
            <li
              class="page-item"
              :class="{ active: link.active }"
              v-for="link in classrooms.meta.links"
              :key="link.label"
            >
              <inertia-link
                v-if="link.url"
                class="page-link"
                :href="link.url"
                preserve-scroll
              >
                <span v-html="link.label"></span>
              </inertia-link>
              <span class="page-link" v-else>
                <span v-html="link.label"></span>
              </span>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <div
      class="modal fade"
      id="deleteConfirmationModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Delete Record - {{ selectedRecord && selectedRecord.name }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            Are you sure you want to delete the record - 
            <strong>{{ selectedRecord && selectedRecord.name }}</strong> ?
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancel
            </button>

            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="
                deleteRecord(selectedRecord ? selectedRecord.id : null)
              "
            >
              Yes, Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";

export default {
  layout: AppLayout,
  props: {
    classrooms: Object,
    searchQuery: String,
    flash: Object,
  },
  data() {
    return {
      selectedRecord: null,
    };
  },
  methods: {
    search() {
      this.$inertia.get(route("classrooms.index"), {
        search_query: this.searchQuery,
      });
    },
    showDeleteConfirmationModal(record) {
      this.selectedRecord = record;
      $("#deleteConfirmationModal").modal("show");
    },
    deleteRecord(id) {
      this.$inertia.delete(route("classrooms.destroy", id));
    },
    navigateToEdit(Id) {
      this.$inertia.get(route('classrooms.edit', Id))
    },
    toggleActions(id) {
      $('#dropdown-toggle-' + id).dropdown('toggle')
    }
  },
};
</script>